import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbConfigVoip } from 'app/abstract/full-pages/voip/config-voip.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigVoipService extends AbConfigVoip {

  prefixo = "config_voip";

  constructor(http: HttpClient) {
    super(http);
  }

  public salvar(configVoip: any): Observable<any> {
    return this.save(`${this.prefixo}/`, configVoip);
  }
  public async salvarAsync(configVoip: any): Promise<any> {
    return await this.save(`${this.prefixo}/`, configVoip).toPromise();
  }

  public getEmProcesso(): Observable<any> {
    return this.get(`${this.prefixo}/emProcesso`);
  }

  public getLimparStatus(): Observable<any> {
    return this.get(`${this.prefixo}/limpaStatus`);
  }

  public getConfigVoip(): Observable<any> {
    return this.get(`${this.prefixo}/padrao`);
  }

  public salvarPorHorario(configVoip: any): Observable<any> {
    return this.save(`admin/${this.prefixo}/`, configVoip);
  }

  public getConfigsPorHorario(filter: AppFilter): Observable<any> {
    return this.get(`admin/${this.prefixo}/filter/${filter.encode()}`);
  }

  public desativarPorHorario(configVoip: any): Observable<any> {
    return this.delete(`admin/${this.prefixo}/`, configVoip);
  }

  public desativar(id: number): Observable<any> {
    return this.delete(`${this.prefixo}`, id);
  }
}
